import { Module } from "vuex";
import { RootState } from "../types";
import { GeneralState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: GeneralState = {
  activeCoachmark: 0,
};

const namespaced: boolean = true;

export const general: Module<GeneralState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
